import _cloneDeep from "lodash/cloneDeep";
import {
  CHANGE_STATE_MODAL_MIGRATE,
  MIGRATE_CLIENTS_REQUESTED,
  MIGRATE_CLIENTS_SUCCESS,
  MIGRATE_DEALS_REQUESTED,
  MIGRATE_DEALS_SUCCESS,
  MIGRATE_ERROR_MESSAGE,
  OPEN_ALERT_MIGRATE_SUCCESS,
  SET_INDEX_CLIENTS_REQUESTED,
  SET_INDEX_CLIENTS_SUCCESS,
  SET_INDEX_DEALS_REQUESTED,
  SET_INDEX_DEALS_SUCCESS,
} from "../actions/actionTypes";

const initialState = {
  errorMessage: '',
  isLoadingClient: false,
  isLoadingDeal: false,
  isLoadingIndex: false,
  isOpen: false,
  integratedClientCount: null,
  integratedDealCount: null,
  isAlert: false
}

const mcsIntegrationReducer = (state = _cloneDeep(initialState), action) => {
  switch (action.type) {
    case MIGRATE_CLIENTS_REQUESTED: {
      return {
        ...state,
        isLoadingClient: true,
        errorMessage: ''
      }
    }
    case MIGRATE_CLIENTS_SUCCESS:
      return {
        ...state,
        integratedClientCount: action.payload.integratedClientCount,
        isLoadingClient: false,
        errorMessage: '',
        isAlert: true
      }
    case MIGRATE_DEALS_REQUESTED:
      return {
        ...state,
        isLoadingDeal: true,
        errorMessage: '',
      }
    case MIGRATE_DEALS_SUCCESS:
      return {
        ...state,
        integratedDealCount: action.payload.integratedDealCount,
        isLoadingDeal: false,
        errorMessage: '',
        isAlert: true
      }
    case MIGRATE_ERROR_MESSAGE:
      return {
        ...state,
        isLoadingClient: false,
        isLoadingDeal: false,
        isLoadingIndex: false,
        errorMessage: action.payload,
        integratedClientCount: null,
        integratedDealCount: null,
      }
    case CHANGE_STATE_MODAL_MIGRATE:
      return {
        ...state,
        isOpen: action.payload
      }
    case OPEN_ALERT_MIGRATE_SUCCESS:
      return {
        ...state,
        isAlert: false
      }
    case SET_INDEX_CLIENTS_REQUESTED:
      return {
        ...state,
        isLoadingIndex: true,
        errorMessage: '',
      }
    case SET_INDEX_CLIENTS_SUCCESS:
      return {
        ...state,
        isAlert: true,
        isLoadingIndex: false,
        errorMessage: '',
      }
    case SET_INDEX_DEALS_REQUESTED:
      return {
        ...state,
        isLoadingIndex: true,
        errorMessage: '',
      }
    case SET_INDEX_DEALS_SUCCESS:
      return {
        ...state,
        isAlert: true,
        isLoadingIndex: false,
        errorMessage: '',
      }
    default:
      return state
  }
}

export default mcsIntegrationReducer
